import { render } from "./MobileApp.vue?vue&type=template&id=52064287"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"

import "./MobileApp.vue?vue&type=style&index=0&id=52064287&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__